import React, { Component } from 'react';
import Vas from '../Vas';
//import { LinkButton } from 'component-lib';

class RegisterSuccess extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

   render()
    {
        return ( <div className="LoginContainer">
          <div className={"form"}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["RegisterSuccessfully"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={2}>{Vas.Resources.Labels["RegisterHint"]}</td>
                </tr>
                {/*<tr>
                  <td style={{ width:'102px', fontSize:'14px', paddingTop:'50px' }}>{Vas.Resources.Labels["LinkLogin"]}</td>
                  <td><LinkButton
                    Text={Vas.Resources.Menus["Login"]}
                    Id={"LinkLogin"}
                    OnClick={()=>{Vas.GetView("Login");}} /></td>
                </tr>*/}
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default RegisterSuccess;
